import React from "react";
import { ShieldCheck, ShieldAlert } from "lucide-react";

export default function StatusBadge({ valid, isActive, expiresAt }) {
  const expired = expiresAt && new Date(expiresAt) < new Date();
  if (!valid) {
    return (
      <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs"
        style={{ background: "rgba(153,27,27,0.18)", color: "#FCA5A5", border: "1px solid rgba(252,165,165,0.3)" }}>
        <ShieldAlert className="w-3.5 h-3.5" /> Not authentic
      </span>
    );
  }
  if (expired) {
    return (
      <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs"
        style={{ background: "rgba(120,53,15,0.2)", color: "#FCD34D", border: "1px solid rgba(252,211,77,0.3)" }}>
        <ShieldCheck className="w-3.5 h-3.5" /> Authentic · expired
      </span>
    );
  }
  if (!isActive) {
    return (
      <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs"
        style={{ background: "rgba(82,82,91,0.25)", color: "#D4D4D8", border: "1px solid rgba(212,212,216,0.3)" }}>
        <ShieldCheck className="w-3.5 h-3.5" /> Authentic · revoked
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs"
      style={{ background: "rgba(22,101,52,0.18)", color: "#86EFAC", border: "1px solid rgba(134,239,172,0.3)" }}>
      <ShieldCheck className="w-3.5 h-3.5" /> Authentic
    </span>
  );
}
